import { Link } from 'react-router-dom';
import { Crown, Map, MessageCircle, Gift, ShoppingCart, Users } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const quickAccessItems = [
  { 
    title: 'لوحة المدير التنفيذي', 
    desc: 'مؤشرات الأداء الشاملة', 
    icon: Crown, 
    link: '/ceo-dashboard', 
    color: 'text-purple-600 bg-purple-50 border-purple-100 hover:border-purple-300' 
  },
  { 
    title: 'تتبع مباشر', 
    desc: 'خريطة الشحنات والمندوبين', 
    icon: Map, 
    link: '/track', 
    color: 'text-blue-600 bg-blue-50 border-blue-100 hover:border-blue-300' 
  },
  { 
    title: 'نظام واتساب', 
    desc: 'إدارة القوالب والرسائل', 
    icon: MessageCircle, 
    link: '/whatsapp', 
    color: 'text-green-600 bg-green-50 border-green-100 hover:border-green-300' 
  },
  { 
    title: 'نظام الولاء', 
    desc: 'نقاط العملاء والإحالات', 
    icon: Gift, 
    link: '/loyalty', 
    color: 'text-amber-600 bg-amber-50 border-amber-100 hover:border-amber-300' 
  },
  { 
    title: 'المتجر الإلكتروني', 
    desc: 'إدارة المنتجات والطلبات', 
    icon: ShoppingCart, 
    link: '/store', 
    color: 'text-indigo-600 bg-indigo-50 border-indigo-100 hover:border-indigo-300' 
  },
  { 
    title: 'لوحة المندوب', 
    desc: 'مهام وتحديثات المندوبين', 
    icon: Users, 
    link: '/delegate-dashboard', 
    color: 'text-cyan-600 bg-cyan-50 border-cyan-100 hover:border-cyan-300' 
  }
];

export default function QuickAccessGrid() {
  return (
    <div className="mb-6 bg-gray-50 border border-gray-200 rounded-xl p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <span className="w-1 h-6 bg-blue-600 rounded-full"></span>
        الوصول السريع للميزات المتقدمة
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {quickAccessItems.map((item, index) => (
          <Link key={index} to={item.link}>
            <Card className={`border transition-all duration-200 hover:shadow-md h-full ${item.color}`}>
              <CardContent className="p-4 flex flex-col items-center text-center gap-3">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center bg-white shadow-sm`}>
                  <item.icon className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm">{item.title}</h3>
                  <p className="text-xs text-gray-600 mt-1">{item.desc}</p>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
